<template>

  <div>
    <div class="hit-form-group">
      <label class="hit-html-label" v-html="$t('message.notifyMeViaEmail')"/>
      <hit_toggle :data="get_data()" :value="get_value()" :callback="function(ret){ set_value(ret); }"/>
    </div>
    <div class="hit-form-group">
      <label class="hit-html-label" >{{ $t("message.importFromHitorShit") }}</label>
      <router-link :to="{ name: 'hitorshit', params: {lang:$route.params.lang} }" class="hit-btn hit-btn-default"><hit_icon :id="'transfer'" /></router-link>
    </div>
  </div>

</template>

<script>

export default{

  methods: {

    set_value (ret) {
      var hit_settings = this.$store.getters.user.hit_settings

      if (typeof hit_settings === 'undefined' || hit_settings == '') { hit_settings = {} } else { hit_settings = JSON.parse(hit_settings) }

      hit_settings.emailNotify = ret

      this.$store.commit('set_change_user', {hit_settings: JSON.stringify(hit_settings)})
    },

    get_value () {
      var hit_settings = this.$store.getters.user.hit_settings

      if (!hit_settings) { hit_settings = {} } else { hit_settings = JSON.parse(hit_settings) }

      if (typeof hit_settings.emailNotify === 'undefined') { return 1 }

      return hit_settings.emailNotify
    },

    get_data () {
      var data = {}

      data[ this.$t('message.yes') ] = 1
      data[ this.$t('message.no') ] = 0

      return data
    }
  }
}

</script>
